import React from 'react';

import { Badge, ProfileCard } from '@change/ds-core-ui';
import { DecisionMakerIcon } from '@change/ds-icons/DecisionMakerIcon';

import { useI18n } from '@change-corgi/core-react/i18n';
import { ClientRender } from '@change-corgi/core-react/ssr/render';

import dmAvatar from '#src/assets/avatars/decision-maker-avatar.png';

import { InfoSection, type InfoSectionConnector } from '../InfoSection';

const NOTIFIED_COUNT = 1000;

export const DecisionMakerSection: React.FC<Props> = ({ className, connector }) => {
	const { translate, localizeNumber } = useI18n();

	return (
		<InfoSection
			className={className}
			connector={connector}
			icon={
				<DecisionMakerIcon
					size="medium"
					aria-label={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.decision_makers_alt')}
				/>
			}
			title={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.title')}
			subtitle={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.subtitle')}
			badge={
				<ClientRender
					placeholder={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.notified_badge', {
						count: String(NOTIFIED_COUNT),
					})}
				>
					{() =>
						translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.notified_badge', {
							count: localizeNumber(NOTIFIED_COUNT),
						})
					}
				</ClientRender>
			}
		>
			<ProfileCard
				name="Jennifer Madgic"
				avatar={dmAvatar}
				imgAlt={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.decision_makers_avatar_alt')}
				userRole={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.decision_makers_role')}
				className="elevation-elevated bg-fill-inverse-strong m-auto w-full"
				icon={
					<DecisionMakerIcon
						aria-label={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.decision_makers_alt')}
					/>
				}
			>
				<Badge
					label={translate('corgi.start_a_petition.chat_app_entry.decision_makers_section.decision_makers_badge')}
					variant="success"
					emphasis="weaker"
					className="self-center"
				/>
			</ProfileCard>
		</InfoSection>
	);
};

type Props = {
	className?: string;
	connector?: InfoSectionConnector;
};
